/**
 * Wires the dock-demo store to the active project. Whenever projectStore's
 * meta.siteId changes, this controller calls dockDemoStore.setActiveProject
 * which snapshots the outgoing project's slice to its localStorage bucket
 * and rehydrates the incoming project's bucket (or empty if first load).
 *
 * Without this controller the dock-demo store is a global singleton —
 * missions / docks / imported data leak across project switches. With it,
 * each project has its own strictly isolated bucket keyed by siteId.
 *
 * Mounted at EditorPage level next to the other dock-demo controllers
 * (MissionFlowController, MissionAutoImportController). Returns null —
 * pure side-effect component.
 *
 * Read-only access to projectStore — no writes. Independent stores stay
 * independent; the wiring lives here, not in either store.
 */

import { useEffect } from 'react';
import { useProjectStore } from '../../stores';
import { useDockDemoStore } from '../../stores/dockDemoStore';

export default function DockDemoProjectScopeController() {
  const siteId = useProjectStore((s) => s.meta.siteId ?? null);

  useEffect(() => {
    useDockDemoStore.getState().setActiveProject(siteId);
  }, [siteId]);

  return null;
}
